<template>
  <div class="cpm-wrapper">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false">
      <div class="cpm-content">
        <el-form :model="formData" ref="form" label-width="80px" label-position="top" size="small">
          <el-form-item label="药店信息">
            <el-input v-model="formData.companyName" disabled></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="formData.merchantAddr" disabled></el-input>
          </el-form-item>
          <el-form-item label="收货人姓名">
            <el-input maxlength="10" v-model="formData.receiverName"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input maxlength="11" v-model="formData.receiverMobile"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="textAlign:right">
        <el-button style="border-radius:0" type="primary" @click="onSubmit">确定</el-button>
        <el-button style="border-radius:0" @click="onCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as api from '@/services';
export default {
  props: {
    preAddress: {
      type: Object,
      default: {}
    },
    editItem: {
      type: Object,
      default: {}
    },
    receiveType: {
      type: String,
      default: 'add'
    },
    title: {
      type: String,
      default: '新增收货信息'
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          if (this.receiveType === 'add') {
            this.formData = {
              companyName: this.preAddress.companyName,
              merchantAddr: this.preAddress.merchantAddr,
              receiverName: '',
              receiverMobile: ''
            };
          } else {
            this.formData = {
              companyName: this.preAddress.companyName,
              merchantAddr: this.preAddress.merchantAddr,
              receiverName: '',
              receiverMobile: ''
            };
            this.formData.receiverName = this.editItem.receiverName;
            this.formData.receiverMobile = this.editItem.receiverMobile;
          }
        }
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        companyName: '',
        merchantAddr: '',
        receiverName: '',
        receiverMobile: ''
      }
    };
  },
  mounted() {},
  methods: {
    async onSubmit() {
      const params = {
        receiverName: this.formData.receiverName,
        receiverMobile: this.formData.receiverMobile
      };
      if (this.preAddress.merchantAddrId) {
        params.merchantAddrId = this.preAddress.merchantAddrId;
      }
      if (this.receiveType === 'edit') {
        params.addrId = this.editItem.addrId;
      }
      await api.personal.modifyReceiveAddr(params);
      this.dialogVisible = false;
      this.$emit('ok');
    },
    onCancel() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
